import React from "react";
import Info from "./info.jpg";
import "./Rightpage.css";
// import { Questions } from '../getQuestions.js';
import { useSelector, useDispatch } from 'react-redux';
import { getCurrentQuestion, getQuestions, jumpToQuestion } from "../../features/Questions/questionSlice";


function RightPage() {
  const currentQuestion = useSelector(getCurrentQuestion);
  const dispatch = useDispatch();
  const Questions = useSelector(getQuestions);


  const SmallQuestions = (question) => {
    return (
      <li
        id={question.id}
        key={question.id}
        className={`${question.type} ${question.id === currentQuestion && "zoom"}`}
        onClick={(e) => {
          e.preventDefault();
          dispatch(jumpToQuestion(parseInt(e.target.innerText)));
          // setAns(Questions[currentQ - 1].attempted);
        }}
      >
        <span>{question.id}</span>
      </li>
    );
  };

  return (
    <div className="test-right">
      <>
        <img src={Info} loading= "lazy" alt="Information about Question Submissions" />
      </>
      <div className="bottom-right">
        <ul>{Questions.map(SmallQuestions)}</ul>
      </div>
    </div>
  );
}

export default RightPage;
